import React, { useState } from "react";
import { FaArrowRotateRight } from "react-icons/fa6";
import { RiZoomInFill, RiZoomOutFill } from "react-icons/ri";

const ImageViewerNew = ({ imageUrl, onClose }) => {
  const [rotationAngle, setRotationAngle] = useState(0);
  const [backgroundPosition, setBackgroundPosition] = useState("50% 50%");
  const [overlayPosition, setOverlayPosition] = useState({ x: 0, y: 0 });
  const [isZoomEnabled, setIsZoomEnabled] = useState(false);
  const originalSize = 250;
  const zoomedSize = 400;
  const zoomFactor = zoomedSize / originalSize;
  const overlaySize = originalSize / zoomFactor;
  const handleRotateImage = () => setRotationAngle((p) => p + 90);
  const handleToggleZoom = () => setIsZoomEnabled((p) => !p);
  const handleMouseMove = (e) => {
    if (!isZoomEnabled) return;
    const { offsetX, offsetY, target } = e.nativeEvent;
    const { offsetWidth, offsetHeight } = target;
    const xPercent = (offsetX / offsetWidth) * 100;
    const yPercent = (offsetY / offsetHeight) * 100;
    setBackgroundPosition(`${xPercent}% ${yPercent}%`);
    setOverlayPosition({ x: offsetX - overlaySize / 2, y: offsetY - overlaySize / 2 });
  };
  const handleMouseLeave = () => {
    if (!isZoomEnabled) return;
    setBackgroundPosition("50% 50%");
  };
  return (
    <div className="flex flex-col items-center">
      <button
        className="absolute top-2 text-xl right-2 text-black"
        onClick={onClose}
        aria-label="Close"
      >
        &times;
      </button>
      <div className="flex">
        <div
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{
            width: `${originalSize}px`,
            height: `${originalSize}px`,
            overflow: "hidden",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            transform: `rotate(${rotationAngle}deg)`,
            transition: "transform 0.3s ease",
          }}
        >
          <img
            src={imageUrl}
            alt="Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              pointerEvents: isZoomEnabled ? "none" : "auto",
              userSelect: "none",
            }}
            draggable={false}
          />
          {isZoomEnabled && (
            <div
              style={{
                position: "absolute",
                left: overlayPosition.x,
                top: overlayPosition.y,
                width: `${overlaySize}px`,
                height: `${overlaySize}px`,
                backgroundColor: "rgba(0,0,255,0.25)",
                border: "1px solid blue",
                pointerEvents: "none",
              }}
            />
          )}
        </div>
        {/* Zoomed panel kept as background-image to preserve magnifier */}
        {isZoomEnabled && (
          <div
            style={{
              width: `${zoomedSize}px`,
              height: `${zoomedSize}px`,
              backgroundImage: `url(${imageUrl})`,
              backgroundPosition: backgroundPosition,
              backgroundSize: "200%",
              backgroundRepeat: "no-repeat",
              marginLeft: "20px",
              border: "1px solid #ccc",
            }}
            className="hidden md:block"
          />
        )}
      </div>
      <div className="mt-4 flex gap-4">
        <button
          className="px-4 py-2 bg-red-600 text-white rounded flex items-center justify-center"
          onClick={handleRotateImage}
          aria-label="Rotate image"
        >
          <FaArrowRotateRight className="text-white" />
        </button>
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded"
          onClick={handleToggleZoom}
          aria-pressed={isZoomEnabled}
          aria-label={isZoomEnabled ? "Disable zoom" : "Enable zoom"}
        >
          {isZoomEnabled ? <RiZoomOutFill className="text-white text-xl" /> : <RiZoomInFill className="text-white text-xl" />}
        </button>
      </div>
    </div>
  );
};
export default ImageViewerNew;
